import { useEffect, useRef } from 'react';
import ChatStream from '../api/ChatStream.js';

export function useChatStreaming(apiClient) {
  const chatStreamRef = useRef(null);

  const getChatStream = () => {
    if (!chatStreamRef.current) {
      chatStreamRef.current = new ChatStream(apiClient);
    }
    return chatStreamRef.current;
  };

  useEffect(() => {
    if (!apiClient.sessionEmail || !apiClient.sessionKey) {
      if (chatStreamRef.current) {
        chatStreamRef.current.close();
        chatStreamRef.current = null;
      }
      return;
    }
    if (!chatStreamRef.current) {
      chatStreamRef.current = new ChatStream(apiClient);
    }
    chatStreamRef.current.connect();
  }, [
    apiClient,
    apiClient.sessionEmail,
    apiClient.sessionKey,
  ]);

  useEffect(() => {
    return () => {
      if (chatStreamRef.current) {
        chatStreamRef.current.close();
        chatStreamRef.current = null;
      }
    };
  }, []);

  const askQuestion = (conversationId, text, onToken, onDone) => {
    if (!apiClient.sessionEmail || !apiClient.sessionKey) {
      return apiClient.askChatQuestion(conversationId, text);
    }
    return getChatStream().askQuestion(conversationId, text, onToken, onDone);
  };

  const clearHandlers = () => {
    chatStreamRef.current?.clearHandlers();
  };

  return {
    askQuestion,
    clearHandlers,
  };
}

export default useChatStreaming;
